import { render, staticRenderFns } from "./UserComments.vue?vue&type=template&id=13ec969a&scoped=true"
import script from "./UserComments.vue?vue&type=script&lang=js"
export * from "./UserComments.vue?vue&type=script&lang=js"
import style0 from "./UserComments.vue?vue&type=style&index=0&id=13ec969a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ec969a",
  null
  
)

export default component.exports